import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import {
  HistoryEntryIcon,
  HistoryEntryMainText,
  HistoryEntrySubText,
  HistoryItemProps,
  UserInfoDisplay,
} from "./common";

export const HistoryItemRiskLevelChanged = ({
  item,
  statusesConfig,
}: HistoryItemProps) => {
  const { details } = item;
  const riskLevelChange = details?.riskLevelChange;
  const isReasonOnlyChange =
    !!riskLevelChange?.fromRiskLevel &&
    riskLevelChange.fromRiskLevel === riskLevelChange?.toRiskLevel;

  const getTitle = () => {
    if (isReasonOnlyChange) {
      return "Risk Level Reason Changed";
    }
    if (riskLevelChange?.toRiskLevel) {
      return `Risk Level Changed to ${riskLevelChange.toRiskLevel}`;
    }
    return "Risk Level Changed to Unknown";
  };

  return (
    <>
      <HistoryEntryIcon>
        <TrendingUpIcon sx={{ height: 20, color: "#FF9800" }} />
      </HistoryEntryIcon>

      <HistoryEntryMainText>{getTitle()}</HistoryEntryMainText>

      <UserInfoDisplay item={item} statusesConfig={statusesConfig} />

      {riskLevelChange?.reason && (
        <HistoryEntrySubText label="Reason">
          {riskLevelChange.reason}
        </HistoryEntrySubText>
      )}
      {riskLevelChange?.fromRiskLevel && !isReasonOnlyChange && (
        <HistoryEntrySubText label="From">
          {riskLevelChange.fromRiskLevel}
        </HistoryEntrySubText>
      )}
    </>
  );
};
